import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, UsersIcon } from 'lucide-react';
import { useIsMobile } from '../lib/useIsMobile';
export function AboutSection() {
  const isMobile = useIsMobile();
  const bounceTransition = {
    type: 'spring',
    stiffness: 260,
    damping: 20
  };
  return <section className="relative z-10 py-24 md:py-32 px-4 md:px-8 overflow-hidden" data-id="element-8">
      {/* Decorative elements */}
      <div className="absolute top-10 right-10 w-32 h-32 bg-purple-300 rounded-full border-4 border-gray-800 animate-float opacity-40" data-id="element-9" />
      <div className="absolute bottom-20 left-10 w-24 h-24 bg-yellow-300 rotate-45 border-4 border-gray-800 opacity-40" style={{
      animation: 'wiggle 3s ease-in-out infinite'
    }} data-id="element-10" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-11">
        {/* Heading with animated badges */}
        <motion.h2 initial={{
        y: 50,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1,
        ...bounceTransition
      }} className="text-4xl md:text-6xl lg:text-7xl font-fredoka font-bold text-gray-800 leading-tight mb-8" data-id="element-12">
          A global influencer marketing agency for{' '}
          <motion.span className="inline-block px-6 py-3 bg-gradient-to-r from-purple-400 to-pink-400 text-white rounded-3xl border-4 border-gray-800 shadow-[6px_6px_0px_rgba(45,55,72,1)]" animate={{
          rotate: [-2, 2, -2],
          y: [0, -5, 0]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-13">
            talents
          </motion.span>{' '}
          and{' '}
          <motion.span className="inline-block px-6 py-3 bg-gradient-to-r from-yellow-400 to-orange-400 text-white rounded-3xl border-4 border-gray-800 shadow-[6px_6px_0px_rgba(45,55,72,1)]" animate={{
          rotate: [2, -2, 2],
          y: [0, -5, 0]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.5
        }} data-id="element-14">
            brands
          </motion.span>
          .
        </motion.h2>

        {/* Description */}
        <motion.p initial={{
        y: 30,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        ...bounceTransition
      }} className="text-lg md:text-xl text-gray-600 leading-relaxed font-medium max-w-3xl mx-auto mb-12" data-id="element-15">
          At HorizonIMA, we bridge the gap between creative vision and market
          impact. We operate across borders to deliver authentic connections,
          empowering creators to build sustainable careers while helping brands
          find their unique voice in a crowded digital landscape.
        </motion.p>

        {/* Feature pills */}
        <motion.div initial={{
        y: 30,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        ...bounceTransition
      }} className="flex flex-wrap justify-center gap-6" data-id="element-16">
          <div className="group flex items-center gap-4 px-8 py-5 rounded-3xl bg-white border-3 border-gray-800 shadow-[6px_6px_0px_rgba(110,231,183,0.4)] hover:shadow-[8px_8px_0px_rgba(110,231,183,0.5)] hover:translate-x-[-2px] hover:translate-y-[-2px] transition-all duration-300" data-id="element-17">
            <div className="p-3 bg-green-300 rounded-full border-3 border-gray-800 group-hover:rotate-12 transition-transform" data-id="element-18">
              <GlobeIcon className="w-6 h-6 text-gray-800" data-id="element-19" />
            </div>
            <div className="text-left" data-id="element-20">
              <h4 className="text-gray-800 font-bold font-fredoka text-lg" data-id="element-21">
                Global Reach
              </h4>
              <p className="text-sm text-gray-600 font-medium" data-id="element-22">
                Operating worldwide
              </p>
            </div>
          </div>

          <div className="group flex items-center gap-4 px-8 py-5 rounded-3xl bg-white border-3 border-gray-800 shadow-[6px_6px_0px_rgba(167,139,250,0.4)] hover:shadow-[8px_8px_0px_rgba(167,139,250,0.5)] hover:translate-x-[-2px] hover:translate-y-[-2px] transition-all duration-300" data-id="element-23">
            <div className="p-3 bg-purple-300 rounded-full border-3 border-gray-800 group-hover:rotate-12 transition-transform" data-id="element-24">
              <UsersIcon className="w-6 h-6 text-gray-800" data-id="element-25" />
            </div>
            <div className="text-left" data-id="element-26">
              <h4 className="text-gray-800 font-bold font-fredoka text-lg" data-id="element-27">
                Top Talent
              </h4>
              <p className="text-sm text-gray-600 font-medium" data-id="element-28">
                Curated network
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}